import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFilters from "../../../hooks/useFilters";
import {
    formatCurrency,
    getLink,
    isVendedor,
    toast,
} from "../../../utils/helpers";
import { request } from "../../../utils/request";
import Dropdown from "../../general/Dropdown";
import FiltersContainer from "../../general/FiltersContainer";
import Loader from "../../general/Loader";
import Modal from "../../general/Modal";
import PageHeader from "../../general/PageHeader";
import Pagination from "../../general/Pagination";
import ReportesForm from "../../Reportes/Form";
import { get } from "lodash";
import { apiRequest } from "../../../hooks/apiRequest";

const Reportes = () => {
    const [showForm, setShowForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [reporte, setReporte] = useState({});

    const toggleModal = (getData = false) => {
        setShowForm(!showForm);
        if (getData) {
            getReportes();
        };
    };

    const toggleDelete = (reporte= false) => {
        setShowDelete(!showDelete);
        if (reporte) {
            setReporte(reporte);
        };
    };

    const { filters, handleFilterChange, filtersQuery } = useFilters({
        buscar: "",
        tipo: "",
        desde: isVendedor()
            ? dayjs().format("YYYY-MM-DD")
            : dayjs().startOf("month").format("YYYY-MM-DD"),
        hasta: dayjs().format("YYYY-MM-DD"),
    });
    const [reportes, setReportes] = useState({ data: [] });
    const [isLoading, setIsLoading] = useState(true);

    const getReportes = async (url) => {
        url = url ? url + "&limit=15" : "listado-reportes?limit=15";
        request(url).then((data) => {
            setReportes(data);
            setIsLoading(false);
        });
    };

    const deleteReporte = async (id) => {
        const response =  await apiRequest(null, `reportes/${id}`, 'delete');

        if (response.success) {
            toast("Reporte eliminado correctamente.");
            getReportes();
        } else {
            toast("El reporte no pudo ser eliminado.", "error");
        }

        toggleDelete(false);
    }

    useEffect(() => {
        if (filtersQuery === "") return;
        getReportes(`listado-reportes${filtersQuery}`);
    }, [filtersQuery]);

    return (
        <>
            <PageHeader title="Reportes" hasButton={false}>
                <div className="d-inline-block float-right h-100 d-flex align-items-center">
                    <button
                        type="button"
                        className="au-btn au-btn-icon au-btn--green au-btn--small"
                        onClick={() => toggleModal()}
                    >
                        <i className="zmdi zmdi-plus" /> Generar Reporte
                    </button>
                </div>
            </PageHeader>
            <FiltersContainer>
                <div className="col">
                    <label>Buscar</label>
                    <input
                        type="search"
                        placeholder="Buscar..."
                        className="form-control"
                        name="buscar"
                        onChange={(e) =>
                            handleFilterChange("buscar", e.target.value)
                        }
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 pr-lg-0">
                    <label
                        htmlFor="desde"
                        style={{ fontSize: "12px", textTransform: "uppercase" }}
                    >
                        Desde
                    </label>
                    <input
                        type="date"
                        name="desde"
                        id="desde"
                        className="form-control"
                        value={filters.desde}
                        onChange={(e) =>
                            handleFilterChange("desde", e.target.value)
                        }
                        disabled={isVendedor()}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-2 pr-lg-0">
                    <label
                        htmlFor="hasta"
                        style={{ fontSize: "12px", textTransform: "uppercase" }}
                    >
                        Hasta
                    </label>
                    <input
                        type="date"
                        name="hasta"
                        id="hasta"
                        defaultValue={filters.hasta}
                        className="form-control"
                        onChange={(e) =>
                            handleFilterChange("hasta", e.target.value)
                        }
                        disabled={isVendedor()}
                    />
                </div>
            </FiltersContainer>
            <div
                className="row px-3"
                style={{ overflowX: "auto", paddingBottom: "5rem" }}
            >
                {isLoading && <Loader />}
                {!isLoading && reportes.data?.length ? (
                    <>
                        <table className="table table-data2">
                            <thead>
                                <tr>
                                    <th>Tipo</th>
                                    <th width="300px">Nombre</th>
                                    <th>Periodo</th>
                                    <th>Fecha de Creación</th>
                                    <th>Creado por</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportes.data.map(reporte => (
                                    <tr>
                                        <td>{reporte.tipo}</td>
                                        <td>{reporte.nombre}</td>
                                        <td>Desde {dayjs(reporte.fecha_inicio).format("DD/MM/YYYY")} hasta {dayjs(reporte.fecha_fin).format("DD/MM/YYYY")}</td>
                                        <td>{reporte.fecha}</td>
                                        <td>{reporte.creador ||'Automático'}</td>
                                        <td className="text-right">
                                            <Link to={getLink(`/imprimir/reportes?reporte=cierre-anual&id=${reporte.id}`)} target="_blank" className="btn btn-sm btn-secondary">
                                                Imprimir
                                            </Link>
                                            <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => toggleDelete(reporte)}>
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                ) : (
                    <div>
                        {!isLoading && (
                            <div>No hay ningún reporte creado.</div>
                        )}
                    </div>
                )}
                {reportes.links && reportes.data?.length > 0 && (
                    <Pagination
                        links={reportes.links}
                        meta={reportes.meta}
                        getData={getReportes}
                    />
                )}
            </div>
            <Modal
                show={showForm}
                blank={true}>
                <ReportesForm
                    toggle={toggleModal}
                />
            </Modal>

            <Modal
                title='Borrar Reporte'
                show={showDelete}
                callback={() => deleteReporte(reporte.id)}
                acceptText="Borrar"
                toggle={toggleDelete}>
                ¿Seguro que deseas el reporte {reporte.nombre}?
            </Modal>
        </>
    );
};

export default Reportes;
